const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      paddingTop: (props) => (props.headerHeight + 80),
      color: theme.colors[0],
    },
    cover: {
      extend: theme.wrapper,
      position: 'relative',
      zIndex: 1,
      marginBottom: 30,
      '& h1': {
        textTransform: 'uppercase',
        margin: 0,
        fontSize: 'calc(52px + 6vw)',
        color: theme.colors[11],
        fontFamily: theme.fonts[1],
        lineHeight: '0.9',
      },
      '& .Hero__title': {
        textTransform: 'uppercase',
        fontSize: 'calc(52px + 6vw)',
        color: theme.colors[11],
        lineHeight: '0.9',
      },
    },
    fullViewport: {
      position: 'absolute',
      top: 0,
      width: '100vw',
      height: '100vh',
      fallback: {
        height: 'calc(var(--vh) * 100)',
      },
    },
    scrollIndicator: {
      padding: '0 5vw',
      position: 'absolute',
      bottom: 0,
      left: 0,
      '& .ScrollIcon__line': {
        background: theme.colors[11],
      },
    },
    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
      paddingTop: 150,
    },
    wrapperNoPaddingTop: {
      paddingTop: 0,
    },
    wrapperDoublePaddingTop: {
      paddingTop: 300,
    },
    revealText: {
      fontSize: 50,
      lineHeight: 1.5,
      '& em': {
        fontFamily: theme.fonts[2],
        fontStyle: 'normal',
        '&:hover': {
          color: theme.colors[2],
          '&::after': {
            background: theme.colors[2],
          },
        },
      },
    },
    columnText: {
      fontSize: 20,
      columns: 2,
      columnGap: 80,
      lineHeight: 1.5,
    },
    video: {
      width: '100%',
      margin: '0 auto',
    },
    gallery: {
      '& .CarouselPagination__root': {
        color: theme.colors[2],
      },
      '& .slick-dots li button::before': {
        borderColor: `${theme.colors[2]} !important`,
      },
      '& .slick-dots li.slick-active button::before': {
        background: `${theme.colors[2]} !important`,
      },
    },
    imgWrapperMobile: {},
  }

  output[theme.mediaInverse.md] = {
    wrapper: {
      paddingTop: 150,
    },
  }

  output[theme.mediaInverse.sm] = {
    cover: {
      '& h1': {
        fontSize: 'calc(30px + 4vw)',
      },
    },
    wrapper: {
      paddingTop: 50,
    },
    columnText: {
      columns: 1,
    },
    video: {
      width: '100%',
    },
    revealText: {
      fontSize: 25,
    },
    imgWrapperMobile: {
      paddingTop: 30,
      display: 'flex',
      flexDirection: 'column',
      '& > *:not(:last-child)': {
        marginBottom: 30,
      },
    },
  }

  return output
}

export default style
